import React from 'react';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import { Currency, NumberField, SmallBodyText } from '../../../../../ui-toolkit';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';

export const LoanAmount: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  return (
    <SummaryItemWithEdit
      label={`Loan Amount`}
      tab={`summary`}
      field={`loan_amount`}
      onUpdate={(_, value) => onPatchOrderInformation({ loanAmount: value ?? null })}
      order={order}
      editControl={NumberField}
      editProps={{ placeholder: '$###,###.##', mode: 'currency' }}
    >
      {order.transaction.loan_amount ? (
        <Currency data-test-id={'loan-amount'} value={order.transaction.loan_amount} />
      ) : (
        <SmallBodyText intent={`faded`}>-</SmallBodyText>
      )}
    </SummaryItemWithEdit>
  );
};
